import { VStack } from '@chakra-ui/react';
import { colors, spacing } from '../../../../../../App/ChakraTheme';
import styled from '../../../../../../consts/styled';

export const StyledTable = styled(VStack)`
  margin-bottom: ${spacing.BASE};
  padding-bottom: 16px !important;
  margin-top: 0px !important;
  width: 100%;

  .checkCircle {
    margin: 0 auto;
    margin-right: ${spacing.TINY};
  }

  .studentName {
    padding-left: ${spacing.TINY};
    padding-right: ${spacing.TINY};
    color: ${colors.applyOpacity(colors.midnight, 0.9)};
    font-family: 'Open Sans';
    text-align: left;
    width: 200px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }

  .analyticsRow .row-cs {
    align-items: center;
  }

  .analyticsRow {
    align-items: center;
    padding-left: 4px;
  }

  .analyticsRow:nth-child(2n-1) {
    background-color: #dddddd;
  }
`;
